import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BmResponse, ResponseMappingOptions } from '../interfaces';
import { from } from 'rxjs';
import { EnvironmentManager } from './environment-manager.service';


@Injectable()

export class DataAccess {

  constructor(
    private http: HttpClient,
    private env: EnvironmentManager) {}

  /* ---------- public API ---------- */

  public execute<T1 = any, T2 = any, T3 = any, T4 = any>(
    action: string,
    params: object = {},
    postMap: ResponseMappingOptions = {}): Promise<BmResponse<T1, T2, T3, T4>> {

    if (action) {
      Object.assign(params, {action});
    }

    return this.asPromise(this.env.currentEnvironment.executeURL, params, postMap);
  }

  public executeWithObservable(
    action: string,
    params: object,
    postMap: ResponseMappingOptions = {}) {

    return from(this.execute(action, params, postMap));
  }




  /* ---------- Private implementations ---------- */

  private asPromise(
    apiEndpoint: string,
    payload: object,
    mapOptions: ResponseMappingOptions): Promise<any> {

    return new Promise((resolve, reject) => {

      this.http.post<any>(apiEndpoint, payload)
      .subscribe(response => {

        const { errors } = response;
        if (errors.code) {
          reject(errors.msg);
          return;
        }

        delete response.errors;
        resolve(this.postMap(response, mapOptions));

      });
    });
  }


  private postMap(response, options: ResponseMappingOptions) {

    let { data, additionalInfo, searchBy, extensions } = response;

    const {
      data: dataPath = [],
      additionalInfo: additionalInfoPath = [],
      searchBy: searchByPath = [],
      extensions: extensionsPath = [],
    } = options;

    for (const segment of dataPath) {
      data = data[segment];
    }

    for (const segment of additionalInfoPath) {
      additionalInfo = additionalInfo[segment];
    }

    for (const segment of searchByPath) {
      searchBy = searchBy[segment];
    }

    for (const segment of extensionsPath) {
      extensions = extensions[segment];
    }

    return {data, additionalInfo, searchBy, extensions};

  }
}
